<template>
    <div>
        <div class="dropdown is-block">
            <div class="dropdown-trigger field">
                <label v-t="'Labels.email_or_username'" class="label"></label>
                <div class="field is-grouped">
                    <p class="control is-expanded has-icons-left">
                        <span class="icon is-small is-left">
                            <i class="fas fa-user" aria-hidden="true" />
                        </span>
                        <input
                            v-model.trim="username"
                            v-validate="'email'"
                            :placeholder="
                                $t('projectParticipants.invite_email')
                            "
                            class="input"
                            type="text"
                            autocomplete="off"
                            name="memberInput"
                            @keyup.enter="
                                addEmail({
                                    permission: defaultPermission,
                                    email: username,
                                })
                            "
                        />
                    </p>
                    <p class="control">
                        <a
                            v-t="'project_configuration_invite_option'"
                            :disabled="!emailIsValid"
                            class="button"
                            @click="
                                addEmail({
                                    permission: defaultPermission,
                                    email: username,
                                })
                            "
                        >
                        </a>
                    </p>
                </div>
            </div>
            <!--router-link
                v-if="hasSchool"
                v-t="'projectParticipants.user_management'"
                :to="{ name: 'school' }"
                class="button is-link"
            ></router-link-->
        </div>
        <hr class="mt-5" />
        <div>
            <h4
                v-t="'projectParticipants.participants'"
                class="is-title has-text-weight-bold py-4"
            />
            <div v-for="member in localSharedWith" :key="member._id">
                <div class="level mb-2">
                    <div class="level-left">
                        <div v-if="member.profile" class="level-item">
                            <figure
                                class="image is-24x24 is-pulled-right"
                                style="margin: 5px"
                            >
                                <img
                                    :src="member.profile.avatar"
                                    referrerPolicy="no-referrer"
                                    class="is-rounded"
                                />
                            </figure>
                            <span>
                                <p class="has-text-black has-text-left">
                                    {{
                                        member.profile.username ||
                                        member.profile.email
                                    }}
                                </p>
                                <p class="has-text-grey has-text-left">
                                    {{ member.profile.email }}
                                </p>
                            </span>
                        </div>

                        <div v-else class="level-item">
                            <span>
                                <p class="has-text-black has-text-left">
                                    {{ member.email }}
                                </p>
                                <p
                                    v-t="'projectParticipants.new_user'"
                                    class="has-text-black has-text-left"
                                ></p
                            ></span>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="select">
                            <select v-model="member.permission">
                                <option
                                    v-for="permission in permissionOptions"
                                    :key="permission"
                                    :value="permission"
                                >
                                    {{
                                        $t(
                                            `projectConfiguration.access_${permission}`
                                        )
                                    }}
                                </option>
                            </select>
                        </div>

                        <div class="dropdown is-hoverable is-right">
                            <div class="dropdown-trigger">
                                <button class="button is-flat">
                                    <span
                                        class="icon is-small dropdown-trigger has-text-grey mx-1"
                                    >
                                        <i
                                            class="mdi mdi-36px mdi-dots-vertical"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </button>
                            </div>
                            <div
                                id="dropdown-menu"
                                class="dropdown-menu"
                                role="menu"
                            >
                                <div class="dropdown-content">
                                    <a
                                        v-t="
                                            'projectParticipants.remove_permissions'
                                        "
                                        class="dropdown-item"
                                        @click="removeMember(member)"
                                    >
                                    </a>
                                    <a
                                        v-if="member.profile"
                                        v-t="
                                            'projectParticipants.resend_invitation'
                                        "
                                        class="dropdown-item"
                                        @click="
                                            $emit('resendInvitation', member)
                                        "
                                    >
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p
                    v-t="
                        `projectConfiguration.access_${member.permission}_description`
                    "
                    class="is-7 is-italic pb-3"
                ></p>
                <hr />
            </div>
        </div>
    </div>
</template>

<script>
import { fetchItems } from '@/services/API';
import { PERMISSION_OPTIONS } from '@/lib/constants';
import { validators } from '@/lib/helpers';
import _ from 'underscore';
export default {
    props: {
        defaultPermission: {
            type: String,
            default: 'read',
        },
        sharedWith: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            username: undefined,
            permissionOptions: PERMISSION_OPTIONS,
            localSharedWith: _.clone(this.sharedWith),
        };
    },
    computed: {
        searchUsers() {
            /* addProjectMember({
                profile,
                permission: defaultPermission,
              })*/

            return _.debounce(this._searchUsers, 400);
        },
        emailIsValid() {
            return validators.email.test(this.username); // !this.errors.has("email");
        },
        hasSchool() {
            return this.$store.getters.hasSchool;
        },
    },
    watch: {
        localSharedWith: {
            handler() {
                this.$emit('update:sharedWith', this.localSharedWith);
            },
            deep: true,
        },
    },
    methods: {
        addEmail(user) {
            if (!this.emailIsValid) {
                return;
            }
            if (
                _.find(this.localSharedWith, (sharedUser) => {
                    return sharedUser.email == user.email;
                })
            ) {
                return (this.username = null);
            }
            this.searchUsers(user);
            this.username = null;
        },
        addProjectMember(user) {
            if (
                _.find(this.localSharedWith, (sharedUser) => {
                    return sharedUser.profile._id == user.profile._id;
                })
            ) {
                return (this.username = null);
            }

            this.localSharedWith.push(user);
            this.showDropdown = false;
            this.username = null;
        },
        removeMember(member) {
            this.localSharedWith = _.without(this.localSharedWith, member);
        },
        async _searchUsers(user) {
            const users = await fetchItems('profile', {
                _q: user.email,
                _limit: 10,
            }).catch(() => {
                console.error('error fetching profiles');
            });
            if (users) {
                if (1 === users.data.length) {
                    const userExists = _.findIndex(this.localSharedWith, {
                        _id: users.data[0]._id,
                    });
                    console.log('userIndex', userExists);
                    if (userExists >= 0) {
                        return;
                    } else {
                        this.localSharedWith.push({
                            profile: users.data[0],
                            permission: user.permission,
                        });
                        return users.data[0];
                    }
                } else if (0 === users.data.length) {
                    this.localSharedWith.push(user);
                    return user;
                }
            }
        },
    },
};
</script>

<style scoped>
.dropdown-menu {
    width: 100% !important;
}
</style>
